import { createContext, useContext, useState } from 'react';

const PaymentMethodContext = createContext();

export const PaymentMethodProvider = ({ children }) => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [showPaymentMethod, setShowPaymentMethod] = useState(false);

  const handleSubmit = () => {
    if (selectedMethod) {
      setShowPaymentMethod(selectedMethod?.type?.toLowerCase());
    }
  };

  return (
    <PaymentMethodContext.Provider
      value={{
        selectedMethod,
        setSelectedMethod,
        showPaymentMethod,
        setShowPaymentMethod,
        handleSubmit,
      }}
    >
      {children}
    </PaymentMethodContext.Provider>
  );
};

export const usePaymentMethod = () => {
  const context = useContext(PaymentMethodContext);
  if (!context) {
    throw new Error(
      'usePaymentMethod must be used within a PaymentMethodProvider'
    );
  }
  return context;
};
